module.exports = {
  WEEKDAY_NUMBERS: [1, 2, 3, 4, 5, 6, 7],
  WEEKDAY_ABBREVIATIONS: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
  WEEKDAY_NAMES: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  START_OF_DAY: '00:00',
  END_OF_DAY: '24:00',
  TIME_NOT_SELECTED: '----',
  HOURS_BEING_SAVED_MESSAGE: 'Hours have been accepted and will be updated on GasBuddy within 15 minutes',
};
